import React from "react";
import Div from "@jumbo/shared/Div";
import { Typography, Button, Box } from "@mui/material";
import { ASSET_CODINGPAL } from "app/utils/constants/paths";
import { ROUTES } from "app/utils/constants/routeConstants";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <Div
      sx={{
        display: "flex",
        flexDirection: { xs: "column", lg: "row" },
        justifyContent: "center",
        alignItems: "center",
        gap: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: 1,
        }}
      >
        <Typography
          variant="h3"
          color="text.primary"
          sx={{ textAlign: "center", fontSize: { xs: "28px", md: "40px" } }}
          fontWeight={700}
        >
          Master Data Structures & Algorithms. Ace your interviews
        </Typography>
        <Button
          variant="contained"
          color="warning"
          sx={{ mb: 0.5, alignSelf: "center", textTransform: "none" }}
          onClick={() => navigate(ROUTES.ALGOS_AND_DS)}
          aria-label="Learn more about mastering DSA"
        >
          Explore problems
        </Button>
      </Box>
      <Box width={{ xs: "100%"}}>
        <img
          src={`${ASSET_CODINGPAL}/CodingPal-Home-no-background.gif`}
          alt="CodingPal DSA Learning Illustration"
          style={{
            maxWidth: "100%",
            maxHeight: { xs: "300px", md: "500px" },
            objectFit: "contain",
          }}
          loading="lazy"
        />
      </Box>
    </Div>
  );
};

export default HeroSection;
